import { SystemStyleObject } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'

const tokens = {
  dark: {
    border: 'interactive.tertiary-border',
    hoverBorder: 'interactive.tertiary-hover-border',
    activeBorder: 'interactive.tertiary-active-border',
    iconColor: 'icon.secondary',
    menuBg: 'bg.card-elevated',
    menuBorder: 'border.subtle',
    itemHoverBg: 'bg.card',
    itemText: 'text.primary',
    itemSelectedBg: 'bg.card',
  },
  light: {
    border: 'light.interactive.tertiary-border',
    hoverBorder: 'light.interactive.tertiary-border',
    activeBorder: 'light.interactive.tertiary-border',
    iconColor: 'light.icon.secondary',
    menuBg: 'light.bg.card',
    menuBorder: 'light.border.subtle',
    itemHoverBg: 'light.bg.table-row-hover',
    itemText: 'light.text.primary',
    itemSelectedBg: 'light.bg.table-row-hover',
  },
} as const

export const priorityDropdownWrapperStyles: SystemStyleObject = {
  position: 'relative',
  display: 'inline-flex',
}

export const priorityDropdownTriggerStyles = (
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  alignItems: 'center',
  bg: 'transparent',
  border: '1px solid',
  borderColor: tokens[colorScheme].border,
  cursor: 'pointer',
  display: 'inline-flex',
  gap: '4px',
  px: '8px',
  py: '4px',
  _hover: {
    borderColor: tokens[colorScheme].hoverBorder,
  },
})

export const priorityDropdownChevronStyles = (
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  color: tokens[colorScheme].iconColor,
  flexShrink: 0,
})

export const priorityDropdownMenuStyles = (
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  bg: tokens[colorScheme].menuBg,
  border: '1px solid',
  borderColor: tokens[colorScheme].menuBorder,
  boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.4)',
  mt: '4px',
  overflow: 'clip',
  position: 'absolute',
  right: 0,
  top: '100%',
  w: '214px',
  zIndex: 11,
})

export const priorityDropdownItemStyles = (
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  alignItems: 'center',
  bg: 'transparent',
  color: tokens[colorScheme].itemText,
  cursor: 'pointer',
  display: 'flex',
  fontFamily: "'Soehne', sans-serif",
  fontSize: '12px',
  fontWeight: 400,
  gap: '10px',
  h: '40px',
  lineHeight: '16px',
  px: '10px',
  py: '4px',
  _hover: { bg: tokens[colorScheme].itemHoverBg },
})
